import { Directive, TemplateRef, input } from '@angular/core';

import { generateUuid } from '@core/utils-legacy';

import { SelectTemplatesService } from '../services/select-templates.service';

@Directive({
  standalone: true,
  selector: '[rtSelectHeaderTemplate]',
})
export class Select2HeaderTemplateDirective {
  private readonly uuid = generateUuid();

  public readonly rtSelectHeaderTemplate = input<number>(undefined!);

  constructor(
    private templateRef: TemplateRef<void>,
    private selectTemplatesService: SelectTemplatesService,
  ) {}

  public ngOnInit() {
    this.selectTemplatesService.headerTemplateRegister({
      id: this.uuid,
      index: this.rtSelectHeaderTemplate(),
      template: this.templateRef,
    });
  }

  public ngOnDestroy() {
    this.selectTemplatesService.headerTemplateRemove(this.uuid);
  }
}
